import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const allAttachesBttn = isFeature('all-attaches-bttn');
